class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");

		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});

		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("cart-overflow-hidden");
		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("cart-overflow-hidden");
		document.body.classList.remove("overflow-hidden");

		setTimeout(() => {
			let notification = this.querySelector(".notification");

			if (notification) {
				const activeItem = this.querySelector(
					`.cart-item[data-product-id="${this.productId}"`
				);
				notification.classList.remove("notification-open");
				activeItem?.classList.remove("active");
			}
		}, 1000);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		let notification = this.querySelector(".notification");

		if (notification) {
			const activeItem = this.querySelector(
				`.cart-item[data-product-id="${this.productId}"`
			);
			notification.classList.add("notification-open");
			activeItem.classList.add("active");
		}

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"input",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}

$(document).ready(function () {
  cartDataInit ();
})

// $('.drawer').on('click', '.drawer__footer .toCart #CartDrawer-Checkout', function() {
// 	$(this).attr('loading', true);
// })

$('.drawer, .main-cart__wrapper').on('click', '.cart-item .quantity__button,.cart-item cart-remove-button button', function() {
  setTimeout(() => {
    cartDataChange();
  }, 1000);
});
$('.drawer, .main-cart__wrapper').on('blur', '.cart-item .quantity__input', function() {
  setTimeout(() => {
    cartDataChange();
  }, 1000);
});

$('.coupon h2 span').on('click', function() {
	$('.coupon input').val($(this).text());
	$('.coupon button').click();
})

$('.coupon input').on('change', function() {
	$('.coupon input').css('borderColor', 'currentColor');
})
$('.coupon input').on("keydown", function (event) {
  if (event.which == 13) {
		$('.coupon button').click();
  }
})
$('.coupon button').on('click', function() {
	if ($('.coupon input').val().trim().length == 0) {
		$('.coupon input').css('borderColor', '#b11500');
		return;
	}
	$('.coupon .msg').css('display', 'none');
	$('.coupon .success').css('display', 'none');
	var $btn = $(this);
	$btn.attr({'disabled': true, 'loading': true});
	const couponName = $('.coupon input').val().trim();
	
	const OriginType = cartData.cart_level_discount_applications.filter((item) => {
		return item.title.toLowerCase() == couponName.toLowerCase();
	});
	var ProductType = false;
	$.each(cartData.items, function(i, item) {
		const type = item.discounts.filter((discount) => {
			return discount.title.toLowerCase().includes(couponName.toLowerCase());
		});
		if (type.length > 0) {
			ProductType = true;
		}
	})
	if (OriginType.length > 0 || ProductType) {
		$btn.attr({'disabled': false, 'loading': false});
		$('.coupon .msg').html(`The coupon code '${couponName.toUpperCase()}' has been applied`).css('display', 'flex');
		return;
	}

	var discountArr = [];
	$.each(cartData.cart_level_discount_applications, function(i, item) {
		discountArr.push(item.title.toLowerCase());
	})
	$.each(cartData.items, function(i, item) {
		$.each(item.discounts, function(j, discount) {
			if (!discountArr.includes(discount.title.toLowerCase())) {
				discountArr.push(discount.title.toLowerCase());
			}
		})
	})
	discountArr.push(couponName);
	localStorage.setItem("discount_code", JSON.stringify({
		"discountArr": discountArr,
		"couponName": couponName 
	}));
	fetch('/cart/update.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ discount: discountArr.join(',') }) // 空字符串移除所有折扣
	})
	.then(res => {
		cartDataChange();
		$btn.attr({'disabled': false, 'loading': false});
	})
})

$('.coupon .success span:last-of-type').on('click', function() {
	$(this).parent().css('display', 'none');
});

$('.main-cart, .drawer').on('click', '.gfgFreeGiftReadyToClaimButton', function() {
	setTimeout(() => {
		window.location.href = window.location.pathname;
		setTimeout(() => {
			if ($('cart-drawer').length > 0) {
				document.querySelector('cart-drawer').open();
			}
		}, 1000);
	}, 1000);
})
